export const PrayersName = {
  FAJR: 'FAJR',
  SUNRISE: 'SUNRISE',
  DHUHR: 'DHUHR',
  ASR: 'ASR',
  MAGHRIB: 'MAGHRIB',
  ISHA: 'ISHA',
} as const;

export type PrayerName = keyof typeof PrayersName;
